import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import MasterDataBaseTable from "../MasterDataBaseTable";
import ProductCategoryModal from "@/Modals/WebDataManagement/MasterData/ProductCategories/Modal";
import React from "react";
import { columns } from "./Columns";
import { productCategoriesMasterDataApi } from "@/apis/apis";

export default function ProductCategoriesPage() {
  return (
    <MasterDataBaseTable
      label="Product Category"
      apiURL={productCategoriesMasterDataApi}
      columns={columns()}
      ModalComponent={ProductCategoryModal}
      importData={BASE_IMPORT_DATA.PRODUCT_CATEGORIES}
    />
  );
}
